import { createSlice } from '@reduxjs/toolkit';
import { forEach } from 'lodash';

// Applicants for all shifts in the shift records section
const applicantsSlice = createSlice({
  name: 'applicants',
  initialState: {
    data: {},
  },
  reducers: {

    hydrateApplicants: (state, action) => {
      let dict = {};
      action.payload.applicants.forEach( (applicant) => {
        dict[applicant.id] = applicant
      });
      const oldResult = state.data;
      state.data = { ...oldResult, ...dict };
    },

    resetApplicants: (state) => {
      state.data = {};
    },

    updateApplicantStatusToPicked: (state, action) => {
      const applicant = { ...action.payload.applicant, status: 'picked' };
      state.data[action.payload.applicant.id] = applicant
    },

    updateApplicantStatusToDenied: (state, action) => {
      const applicant = { ...action.payload.applicant, status: 'denied' };
      state.data[action.payload.applicant.id] = applicant
    },

  },
});

export default applicantsSlice;